// JsFromRoutes CacheKey a5a1d0c329877f6b886ca4098136cac0
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  doUnlock: /* #__PURE__ */ definePathHelper('post', '/users/unlock/do_unlock'),
  resendUnlockInstructionsFromToken: /* #__PURE__ */ definePathHelper('post', '/users/unlock/resend_unlock_instructions_from_token'),
}
